export const API_ENV = 'staging';

const API_URLS = {
  production: 'https://drmatabackend-584749671098.asia-southeast1.run.app',
  staging: 'https://dr-mata-backend-staging-584749671098.asia-southeast1.run.app',
};

function normalizeUrl(url) {
  return url.replace(/\/+$/, '');
}

export const API_BASE_URL = normalizeUrl(API_URLS[API_ENV] || API_URLS.production);

export function apiUrl(path = '') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

export function getRoleApiPath(userRole) {
  if (userRole === 'clinic_admin') {
    return '/nora_clinicadmin';
  }

  if (userRole === 'state_health_org') {
    return '/nora_state_org';
  }

  return '/nora_superadmin';
}
